import { computed } from 'vue'
import { defineNuxtPlugin, useHead, useRoute } from '#app'
import type { Router } from 'vue-router'
import { forceUnlockBody } from '@/composables/useBodyScrollLock'
import { HOME_REM_OFF_CLASS, isNewHomeRoute } from '@/utils/homeRem'

export default defineNuxtPlugin((nuxtApp) => {
  try {
    const route = useRoute()

    // SSR + 客户端路由：首屏 HTML 即带 class，避免刷新后 padding 缺失再跳变
    useHead({
      htmlAttrs: {
        class: computed(() =>
          isNewHomeRoute(route.path) ? HOME_REM_OFF_CLASS : undefined,
        ),
      },
    })

    if (!process.client) return

    let remHandlersAttached = false

    function setFont() {
      const html = document.documentElement
      let screenWidth = html.offsetWidth
      if (screenWidth >= 750) screenWidth = 750
      if (screenWidth <= 320) screenWidth = 320
      html.style.fontSize = `${(100 * screenWidth) / 750}px`
      document.body.style.display = 'block'
    }

    const onResize = () => setFont()
    const onLoad = () => setFont()

    function attachRemHandlers() {
      if (remHandlersAttached) return
      remHandlersAttached = true
      window.addEventListener('resize', onResize, false)
      window.addEventListener('load', onLoad, false)
      setFont()
      setTimeout(setFont, 300)
    }

    function detachRemHandlers() {
      if (!remHandlersAttached) return
      remHandlersAttached = false
      window.removeEventListener('resize', onResize, false)
      window.removeEventListener('load', onLoad, false)
    }

    function applyRemForPath(path: string) {
      if (isNewHomeRoute(path)) {
        detachRemHandlers()
        document.documentElement.style.fontSize = ''
      } else {
        attachRemHandlers()
      }
    }

    const router = nuxtApp.$router as Router
    applyRemForPath(router.currentRoute.value.path)
    router.afterEach((to) => {
      applyRemForPath(to.path)
      if (!isNewHomeRoute(to.path)) {
        forceUnlockBody()
      }
    })
  } catch (e) {
    console.warn('[rem] plugin failed safe:', e)
  }
})
